import { PhosphorGearAnchor } from "components/Atoms/PhosphorIconAnchor";
import React from "react";
import { Message } from "components/Atoms/Message";
import { routes } from "utilities/routing/generatedRoutes";

type NoBankAccountsMessageBoxProps = {
  type: "error" | "info";
};

const NoBankAccountsMessageBox = React.forwardRef<HTMLDivElement, NoBankAccountsMessageBoxProps>((props, ref) => {
  return (
    <div ref={ref as React.RefObject<HTMLDivElement>}>
      <Message type={props.type} className="flex margin-bottom gap" style={{ padding: 4 }}>
        <div className="grow1 padding">
          {RESX.BankAccount.NoBankAccountWarning}
        </div>
        <div>
          <PhosphorGearAnchor
            href={routes.bankAccount_List().absolute}
            layout="in-square"
            backgroundColor="light"
            padding="large"
          />
        </div>
      </Message>
    </div>
  );
});

export default NoBankAccountsMessageBox;
